/**
 * 此文件已移动到 @/utils/request.js
 * 请使用 const { get, post, put, del } = require('@/utils/request')
 */

// 兼容旧版本的引用方式
const utils = require('@/utils/request');

// 导出兼容旧版本的API
module.exports = utils; 